/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import ErrorBoundary from 'base/components/ErrorBoundary';
import LabradorJwVideoShoppable from 'base/components/labrador/JwVideo/Shoppable';

export const DynamicLabradorJwVideoShoppable: typeof LabradorJwVideoShoppable = (props) => {
    return <ErrorBoundary><LabradorJwVideoShoppable {...props} /></ErrorBoundary>;
}
export type DynamicLabradorJwVideoShoppableProps = PropsFromComponent<typeof LabradorJwVideoShoppable>;
